module.exports = __webpack_public_path__ + "static/img/thedivTwoTitle.7dc51033.png";